import { PatientUrgencyDOBGate, PatientUrgencyPage } from '@elva/ui';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ElvaPageLoader } from '@/components/ElvaPageLoader';
import { ElvaSectionState } from '@/components/ElvaSectionState';
import {
  adaptPublicUrgencyGate,
  adaptPublicUrgencyPage,
} from '../adapters/publicUrgencyAdapters';
import { usePublicUrgencyGate } from '../hooks/usePublicUrgencyGate';
import { usePublicUrgencyPage } from '../hooks/usePublicUrgencyPage';

/** Patient-facing public page — no app shell or staff nav. */
export function PatientUrgencyPublicPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [verified, setVerified] = useState(false);

  const { data: gate, isLoading: gateLoading, isError: gateError, verifyDob } =
    usePublicUrgencyGate(token);
  const { data: page, isLoading: pageLoading, isError: pageError } = usePublicUrgencyPage(
    token,
    verified,
  );

  if (!token) {
    return <ElvaSectionState isError>{null}</ElvaSectionState>;
  }

  if (gateLoading) {
    return <ElvaPageLoader />;
  }

  if (gateError || !gate) {
    return <ElvaSectionState isError>{null}</ElvaSectionState>;
  }

  const gateView = adaptPublicUrgencyGate(gate);

  if (!verified) {
    return (
      <PatientUrgencyDOBGate
        practice={gateView.practice}
        patient={gateView.patient}
        verifyDob={async (dob) => {
          const result = await verifyDob.mutateAsync(dob);
          return result.verified;
        }}
        onVerified={() => setVerified(true)}
      />
    );
  }

  if (pageLoading) {
    return <ElvaPageLoader />;
  }

  if (pageError || !page) {
    return <ElvaSectionState isError>{null}</ElvaSectionState>;
  }

  const pageView = adaptPublicUrgencyPage(page);

  return (
    <PatientUrgencyPage
      patient={pageView.patient}
      practice={pageView.practice}
      aiSummary={pageView.aiSummary}
      treatments={pageView.treatments}
    />
  );
}
